module.exports = __webpack_public_path__ + "static/media/icon-recuperacao-previdenciaria.60da8776.svg";